var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topbar"},[_c('a',{staticClass:"back-btn",staticStyle:{"cursor":"pointer"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v("返回 ")]),_c('div',{staticClass:"tips"},[_vm._v(" 欢迎回到智训立方课程空间。您可以在这里维护课程内容、组织案例学习和查看训练反馈。 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }